// VUE_APP_* values are inlined at build time, and one image is promoted
// across environments. nginx writes /config.js from the pod's VUE_APP_* env
// at container start (nginx/docker-entrypoint.d/40-app-config.sh); any key
// set there overrides the build-time value, the rest fall back unchanged.
type Env = Record<string, string | undefined>

declare global {
  interface Window {
    __APP_CONFIG__?: Env
  }
}

export function mergeEnv(build: Env, runtime: Env | undefined): Env {
  return { ...build, ...runtime }
}

export const env: Env = mergeEnv(
  process.env,
  typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined
)
